import { useEffect, useState } from 'react';
import * as S from './styles';
import { RiArrowUpLine } from 'react-icons/ri';

interface ButtonToTopProps {
  onPress?: () => void;
}

const ButtonToTop = ({ onPress }: ButtonToTopProps) => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollPosition]);

  const handleScrollToTop = () => {
    if (onPress) {
      onPress();
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <S.ButtonToTopWrapper onClick={handleScrollToTop} $isVisible={scrollPosition > 100}>
      <RiArrowUpLine />
    </S.ButtonToTopWrapper>
  );
};

export default ButtonToTop;
